import React from 'react';
import { Dropdown, Tooltip } from 'antd';
import { EnvironmentOutlined, SwapOutlined, DownOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearSelectedBranch, setSelectedPlace } from '../../store/slices/branchesSlice';
import { usePlaces } from '../../hooks/usePlaces';
import './index.css';

/**
 * Her sayfanın üstünde duran kapsam çubuğu.
 *
 * Amaç: şube değiştirmek için seçim ekranına dönmek gerekmesin. Branş değişimi
 * şubeyi de sıfırladığı için o hâlâ seçim ekranına gidiyor.
 */
const ScopeBar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedBranch = useSelector((state) => state.branches.selectedBranch);
    const selectedPlace = useSelector((state) => state.branches.selectedPlace);
    const { places } = usePlaces(selectedBranch?.id);

    if (!selectedBranch) return null;

    const handlePlaceChange = ({ key }) => {
        if (key === 'manage') {
            navigate('/locations');
            return;
        }
        const place = places.find((p) => String(p.id) === key);
        if (place) dispatch(setSelectedPlace(place));
    };

    const handleScopeChange = () => {
        dispatch(clearSelectedBranch());
        navigate('/select-sport');
    };

    const placeItems = [
        ...places.map((place) => ({
            key: String(place.id),
            label: place.name,
            icon: <EnvironmentOutlined />
        })),
        { type: 'divider' },
        { key: 'manage', label: 'Şubeleri yönet', icon: <SwapOutlined /> }
    ];

    // Kırıntı mantığı: her iki kademe de kendi değişimini tetikliyor.
    // Branş değişimi şubeyi de sıfırladığı için seçim ekranına dönüyor.
    return (
        <nav className="scope-bar" aria-label="Çalışma alanı">
            <Tooltip title="Branş değiştir">
                <button type="button" className="scope-bar__branch" onClick={handleScopeChange}>
                    <SwapOutlined className="scope-bar__swap" />
                    <span>{selectedBranch.name}</span>
                </button>
            </Tooltip>

            <span className="scope-bar__div" aria-hidden="true" />

            <Dropdown menu={{ items: placeItems, onClick: handlePlaceChange }} trigger={['click']}>
                <button type="button" className="scope-bar__place" aria-label="Şube değiştir">
                    <EnvironmentOutlined className="scope-bar__pin" />
                    <span className="scope-bar__place-name">
                        {selectedPlace ? selectedPlace.name : 'Şube seçin'}
                    </span>
                    <DownOutlined className="scope-bar__chev" />
                </button>
            </Dropdown>
        </nav>
    );
};

export default ScopeBar;
